type Variant = 'active' | 'inactive' | 'archived' | 'warning';

const STYLES: Record<Variant, string> = {
  active: 'bg-status-active-bg text-status-active-text',
  inactive: 'bg-status-inactive-bg text-status-inactive-text',
  archived: 'bg-status-archived-bg text-status-archived-text',
  warning: 'bg-status-warning-bg text-status-warning-text',
};

export default function StatusBadge({
  variant,
  children,
}: {
  variant: Variant;
  children: React.ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-pill px-2.5 py-[3px] text-[11px] font-medium tracking-[0.2px] ${STYLES[variant]}`}
    >
      {children}
    </span>
  );
}
